import { trackRetailerMobileCloseBottomNavClick } from "@faire/web-api/events/retailerMobile/click/closeBottomNav";
import { trackRetailerMobileBottomNavView } from "@faire/web-api/events/retailerMobile/view/bottomNav";
import { trackEvent } from "@faire/web/common/trackEvent";

import { RetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

export const topNavEvent = (name: string) => () => {
  trackEvent(`/retailer/${RetailerStore.get().retailerToken}/top-nav/${name}`);
  if (name === "open") {
    trackRetailerMobileBottomNavView();
  } else if (name === "close") {
    trackRetailerMobileCloseBottomNavClick();
  }
};
